/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RegeneratedDescriptionDTO
 */
export interface RegeneratedDescriptionDTO {
  /**
   *
   * @type {number}
   * @memberof RegeneratedDescriptionDTO
   */
  productId: number;
  /**
   * False when the gate rejected the text; the stored description is untouched.
   * @type {boolean}
   * @memberof RegeneratedDescriptionDTO
   */
  accepted: boolean;
  /**
   * The stored description after this call — the new text, or the old one when rejected.
   * @type {string}
   * @memberof RegeneratedDescriptionDTO
   */
  description: string | null;
  /**
   *
   * @type {number}
   * @memberof RegeneratedDescriptionDTO
   */
  confidence?: number | null;
  /**
   * Whether a second pass with Google Search grounding was needed.
   * @type {boolean}
   * @memberof RegeneratedDescriptionDTO
   */
  grounded: boolean;
  /**
   *
   * @type {string}
   * @memberof RegeneratedDescriptionDTO
   */
  skipReason?: RegeneratedDescriptionDTOSkipReasonEnum;
  /**
   * Why the call failed, in words: the status the model answered and what it means. Only set alongside skipReason API_ERROR — a rejected text is a decision, not a failure.
   * @type {string}
   * @memberof RegeneratedDescriptionDTO
   */
  failureMessage?: string | null;
  /**
   * What the model said it was unsure about.
   * @type {Array<string>}
   * @memberof RegeneratedDescriptionDTO
   */
  uncertainties: Array<string>;
}

/**
 * @export
 */
export const RegeneratedDescriptionDTOSkipReasonEnum = {
  LOW_CONFIDENCE: "LOW_CONFIDENCE",
  BAD_LENGTH: "BAD_LENGTH",
  API_ERROR: "API_ERROR"
} as const;
export type RegeneratedDescriptionDTOSkipReasonEnum =
  typeof RegeneratedDescriptionDTOSkipReasonEnum[keyof typeof RegeneratedDescriptionDTOSkipReasonEnum];

/**
 * Check if a given object implements the RegeneratedDescriptionDTO interface.
 */
export function instanceOfRegeneratedDescriptionDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "productId" in value;
  isInstance = isInstance && "accepted" in value;
  isInstance = isInstance && "description" in value;
  isInstance = isInstance && "grounded" in value;
  isInstance = isInstance && "uncertainties" in value;

  return isInstance;
}

export function RegeneratedDescriptionDTOFromJSON(json: any): RegeneratedDescriptionDTO {
  return RegeneratedDescriptionDTOFromJSONTyped(json, false);
}

export function RegeneratedDescriptionDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegeneratedDescriptionDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    productId: json["productId"],
    accepted: json["accepted"],
    description: json["description"],
    confidence: !exists(json, "confidence") ? undefined : json["confidence"],
    grounded: json["grounded"],
    skipReason: !exists(json, "skipReason") ? undefined : json["skipReason"],
    failureMessage: !exists(json, "failureMessage") ? undefined : json["failureMessage"],
    uncertainties: json["uncertainties"]
  };
}

export function RegeneratedDescriptionDTOToJSON(value?: RegeneratedDescriptionDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    productId: value.productId,
    accepted: value.accepted,
    description: value.description,
    confidence: value.confidence,
    grounded: value.grounded,
    skipReason: value.skipReason,
    failureMessage: value.failureMessage,
    uncertainties: value.uncertainties
  };
}
